import { combineReducers } from 'redux';

import { opinionAnalyticsReducer } from '../analytics/store/reducer';
import { opinionInstanceReducer } from '../instances/store/reducer';
import { myOpinionsReducer } from '../my-opinions/store/reducer';
import { opinionNettingEngineReducer } from '../netting-engine/store/reducer';
import { opinionReportingReducer } from '../reporting/store/reducer';

export const opinionReducer = combineReducers({
    myOpinions: myOpinionsReducer,
    reporting: opinionReportingReducer,
    instance: opinionInstanceReducer,
    analytics: opinionAnalyticsReducer,
    nettingEngine: opinionNettingEngineReducer
});
